import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'

import {slideshow} from './js/sliders'
import {Cart} from './js/cart'
import {loadMore} from "./js/load-more";
import {filters} from "./js/filters";
import {agree} from "./js/agree";
import {search} from "./js/search";
import {zones} from "./js/zones";
import {cities} from "./js/cities";
import {carFilter} from "./js/cars/carFilter";
import { categoryFilter } from './js/categories/categoryFilter';


window.Cart = Cart
window.loadMore = loadMore
window.filters = filters
window.agree = agree
window.zones = zones
window.cities = cities
window.search = search
window.carFilter = carFilter
window.categoryFilter = categoryFilter
window.Alpine = Alpine

Alpine.plugin(persist)
Alpine.start()

window.onload = (() => {
    slideshow()
})

